<template>
  <header :class="appBarClasses" :style="appBarStyle">
    <div class="app-bar__content">
      <div class="app-bar__left">
        <button
          v-if="showMenuButton"
          type="button"
          class="app-bar__menu-btn"
          @click="$emit('toggle-drawer')"
        >
          <svg viewBox="0 0 24 24" width="24" height="24">
            <path fill="currentColor" d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
          </svg>
        </button>
        <slot name="left" />
      </div>

      <div class="app-bar__title">
        <slot name="title">
          {{ title }}
        </slot>
      </div>

      <div class="app-bar__right">
        <slot name="right" />
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppBar',
  props: {
    title: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: null
    },
    flat: {
      type: Boolean,
      default: false
    },
    showMenuButton: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle-drawer'],
  computed: {
    appBarClasses() {
      return [
        'app-bar',
        {
          'app-bar--flat': this.flat,
          'app-bar--fixed': this.fixed
        }
      ]
    },
    appBarStyle() {
      return this.color ? { backgroundColor: this.color } : {}
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../scss/variables' as *;

.app-bar {
  height: $nav-height;
  background: $color-primary;
  color: $color-text-inverse;
  box-shadow: $shadow-sm;
  backdrop-filter: blur(8px);
  overflow: visible;

  &--flat {
    box-shadow: none;
  }

  &--fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: $z-index-fixed;
  }

  &__content {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 $spacing-6;
    gap: $spacing-4;
  }

  &__left {
    display: flex;
    align-items: center;
    gap: $spacing-3;
  }

  &__menu-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    border: none;
    background: rgba(255, 255, 255, 0.1);
    border-radius: $radius-lg;
    color: inherit;
    cursor: pointer;
    transition: all $transition-fast $transition-timing;

    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
      transform: scale(1.02);
    }

    &:active {
      transform: scale(0.98);
    }
  }

  &__title {
    flex: 1;
    font-size: $font-size-lg;
    font-weight: $font-weight-semibold;
    letter-spacing: -0.01em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__right {
    display: flex;
    align-items: center;
    gap: $spacing-3;
  }
}
</style>
